import Tooltip from '@mui/material/Tooltip';
import { IconSparkleHighlight } from '@tabler/icons-react';
import { DashboardCardWrapper } from '../../commonComponents/DashboardCardWrapper';

export const FunnelSnapshot = () => {
    const campaignData = [
        { name: "Visitors", leads: 342, percentage: 85, fill: "#e9dae2", border: "#7a3a5e" },
        { name: "Leads", leads: 215, percentage: 54, fill: "#d6e5f8", border: "#3b82f6" },
        { name: "MQLs", leads: 180, percentage: 45, fill: "#efdfff", border: "#a855f7" },
        { name: "Customer", leads: 95, percentage: 24, fill: "#daf5ef", border: "#14b8a6" },
    ];

    const maxLeads = Math.max(...campaignData.map(c => c.leads));

    return (
        <DashboardCardWrapper
            headerText={"Top Performing Campaigns"}
            headerSubtext={"Lead volume breakdown by channel source."}
            headerIcon={<IconSparkleHighlight color={"#7a3a5e"} stroke={1.8} />}
            componentClassname={" "}
            componentStyles={{ height: "auto", width: "100%" }}
        >
            <div className="d-flex flex-column gap-4 px-1" style={{ marginBottom: '0.4rem' }}>
                {campaignData.map((campaign, idx) => {
                    const relativeWidth = Math.round((campaign.leads / maxLeads) * 100);

                    return (
                        <div key={idx} className="d-flex flex-column gap-2">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-2">
                                    <span
                                        className="rounded-circle d-inline-block"
                                        style={{ width: "6px", height: "6px", backgroundColor: campaign.border }}
                                    />
                                    <span className="fw-medium text-secondary" style={{ fontSize: "12.5px", letterSpacing: "-0.01em" }}>
                                        {campaign.name}
                                    </span>
                                </div>
                                <div className="d-flex align-items-baseline gap-1">
                                    <strong className="fw-bold" style={{ fontSize: "13px", color: "#334155" }}>
                                        {campaign.leads}
                                    </strong>
                                    {/* <span className="text-muted fw-normal" style={{ fontSize: "10.5px" }}>
                                        leads
                                    </span> */}
                                </div>
                            </div>

                            <Tooltip
                                title={`${campaign.name}: ${campaign.leads} leads (${campaign.percentage}% of target)`}
                                placement="top"
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            fontSize: "0.75rem",
                                            backgroundColor: "#ffffff",
                                            border: '1px solid #f1f5f9',
                                            color: "#475569",
                                            fontWeight: 500,
                                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)"
                                        },
                                    },
                                }}
                            >
                                <div
                                    className="w-100 rounded-pill position-relative overflow-hidden cursor-pointer"
                                    style={{ height: "8px", backgroundColor: "#f8fafc" }}
                                >
                                    <div
                                        className="h-100 rounded-pill"
                                        style={{
                                            width: `${relativeWidth}%`,
                                            // height: "1.8rem",
                                            backgroundColor: campaign.fill,
                                            borderRight: `2px solid ${campaign.border}`,
                                            transition: "width 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
                                        }}
                                    />
                                </div>
                            </Tooltip>
                        </div>
                    );
                })}
            </div>
        </DashboardCardWrapper>
    );
};